<template>
    <div>
        <div class="stuContact A4Container flexCloumnCenter">
            <div class="title">无锡机电高等职业技术学校应届毕业生校外实习鉴定表</div>
            <div class="flexCenter" style="height: 40px;width:100%; font-size:14px;">

                <div class="flexEnd" style="height:100%;width:calc( ( 100% - 220px ) / 2);overflow:hidden;">
                    <div class="flex_1 flexCenter"
                        style="height:100%;line-height:unset;border-bottom: 1px solid #303133;overflow:hidden;">
                        {{ formData.profession }}
                    </div>
                    系(部)
                </div>
                <div class="ml10 flexEnd" style="height:100%;width:calc( ( 100% - 220px ) / 2);overflow:hidden;">
                    <div class="flex_1 flexCenter"
                        style="height:100%;line-height:unset;border-bottom: 1px solid #303133;overflow:hidden;">
                        {{ formData.class_name }}
                    </div>
                    班级
                </div>
                <div class="flexCenter" style="width:140px;height:100%;margin-left:20px;">{{
                    formData.identify_date }} </div>
            </div>

            <div class="form">
                <div class="table" style="height: 100%;">
                    <el-row>
                        <el-col :span="4" class="cell cell50 flexCenter" style="border-left: 0;">姓名</el-col>
                        <el-col :span="4" class="cell cellMore flexCenter" style="height:50px;overflow:hidden">{{ formData.stu_name }}</el-col>
                        <el-col :span="3" class="cell cell50 flexCenter">性别</el-col>
                        <el-col :span="4" class="cell cellMore flexCenter" style="height:50px;overflow:hidden">{{ formData.gender == 1 ? '男' : '女' }}</el-col>
                        <el-col :span="3" class="cell cell50 flexCenter">专业</el-col>
                        <el-col :span="6" class="cell cellMore flexCenter" style="height:50px;overflow:hidden">{{ formData.zy_name || formData.yx_name || '-' }}</el-col>
                    </el-row>
                    <el-row>
                        <el-col v :span="4" class="cell cellMore flexCenter" style="border-left: 0;">实习单位</el-col>
                        <el-col :span="20" class="cell cellMore flexCenter">{{ formData.firm_name }}</el-col>
                    </el-row>
                    <el-row>
                        <el-col v :span="4" class="cell cellMore flexCenter" style="border-left: 0;">实习岗位及内容</el-col>
                        <el-col :span="20" class="cell cellMore flexCenter">{{ formData.job_content }}</el-col>
                    </el-row>
                    <el-row class="" style="border-left: 0;width:100%;height: calc( 100% - 550px )">
                        <el-col :span="24" class="cell"
                            style="font-size: unset;width:100%;height: 100%;padding: 10px;border-left: 0;overflow: hidden;box-sizing: border-box;position: relative;">
                            <div id="divCntnrA" style="width:100%;height: 100%;overflow: hidden;">
                                <div id="resizeDivA">
                                    自我鉴定:(主要写表现、收获、体会及成果)
                                    <div class='textIndent2' v-if='formData.contentArr && formData.contentArr.length > 0'
                                        v-for='(item, index) in formData.contentArr'
                                        style="width: 100%;word-break: break-all;white-space: pre-wrap;">{{ item }}</div>
                                    <div class='textIndent2' v-else
                                        style="width: 100%;word-break: break-all;white-space: pre-wrap;"> {{
                                            formData.identify_content }}</div>
                                </div>
                            </div>
                        </el-col>
                    </el-row>


                    <el-row class="flexStretch" style="border-left: 0;width:100%;height: 200px;">
                        <el-col :span="2" class="flexCenter cell cell50"
                            style="text-align: center;border-left: 0;line-height:unset;">
                            车间<br />部门<br />意见</el-col>
                        <el-col :span="10" class="flexCenter cell" style="padding: 10px;">
                            <div :id="'divCntnrA_'"
                                style="width:100%;height: 100%;overflow: hidden;box-sizing: border-box;position: relative;">
                                <div :id="'resizeDivA_'" style="width: 100%;word-break: break-word">
                                    {{ formData.workshop_opinion || '-' }}
                                </div>

                                <div class="flexEnd"
                                    style="position: absolute;bottom: 0;width: calc( 100% - 0px );line-height: 50px;">
                                    <div class="flexStart" style="line-height: unset!important;">
                                        <div>签字：</div>
                                        <img v-if="formData.workshop_signature" :src="formData.workshop_signature" alt=""
                                            style="max-width: 100px;max-height: 50px;">
                                        <div v-else style="width: 100px;"></div>
                                    </div>
                                </div>
                            </div>
                        </el-col>
                        <el-col :span="2" class="flexCenter cell cell50"
                            style="text-align: center;line-height:unset;">公司<br />人事<br />主管<br />部门<br />意见</el-col>
                        <el-col :span="10" class="cell" style="padding: 10px;">


                            <div :id="'divCntnrB_'"
                                style="width:100%;height: 100%;overflow: hidden;box-sizing: border-box;position: relative;">
                                <div :id="'resizeDivB_'" style="width: 100%;word-break: break-word">
                                    {{ formData.personnel_opinion || '-' }}
                                </div>

                                <div class="flexEnd"
                                    style="position: absolute;bottom: 0;width: calc( 100% - 20px );line-height: 50px;">
                                    <div class="flexStart" style="line-height: unset!important;">
                                        <div>等级评定：{{ formData.personnel_grade }}</div>

                                    </div>
                                </div>
                            </div>


                        </el-col>
                    </el-row>

                    <el-row class="flexStretch" style="border-left: 0;width:100%;height: 200px;">
                        <el-col :span="2" class="flexCenter cell cell50"
                            style="text-align: center;border-left: 0;line-height:unset;">
                            学生<br />所在<br />系部<br />意见</el-col>
                        <el-col :span="10" class="flexCenter cell" style="padding: 10px;">
                            <div :id="'divCntnrA_'"
                                style="width:100%;height: 100%;overflow: hidden;box-sizing: border-box;position: relative;">
                                <div :id="'resizeDivA_'" style="width: 100%;word-break: break-word">
                                    {{ formData.department_opinion || '-' }}
                                </div>

                            </div>
                        </el-col>
                        <el-col :span="2" class="flexCenter cell cell50"
                            style="text-align: center;line-height:unset;">学校<br />主管<br />部门<br />意见</el-col>
                        <el-col :span="10" class="cell" style="padding: 10px;">


                            <div :id="'divCntnrB_'"
                                style="width:100%;height: 100%;overflow: hidden;box-sizing: border-box;position: relative;">
                                <div :id="'resizeDivB_'" style="width: 100%;word-break: break-word">
                                    {{ formData.school_opinion || '-' }}
                                </div>

                            </div>


                        </el-col>
                    </el-row>
                </div>

            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'contact',
    data() {
        return {
            dataover: false,
            userid: '',
            formData: [{}],
        }
    },
    props: {
        stuInfo: {
            type: Object,
            default: () => {
                return {}
            }
        },
        type: {
            type: Number,
            default: 1
        }
    },
    mounted() {
        let _this = this
        setTimeout(function () {
            let info = JSON.parse(JSON.stringify(_this.stuInfo))
            _this.formData = info
            _this.$nextTick(() => {
                // console.log(65,_this.formData)
                _this.resizeA()
            })
        }, 500)
    },
    methods: {
        resizeA() {
            let id1 = 'divCntnrA'
            let id2 = 'resizeDivA'

            let divHeight = document.getElementById(id1).offsetHeight
            let textHeight = document.getElementById(id2).offsetHeight
            // console.log('a', divHeight, textHeight)
            let i = 1
            while (textHeight > divHeight && i < 7) {
                document.getElementById(id2).style.fontSize = `${18 - i}px`
                textHeight = document.getElementById(id2).offsetHeight
                i++

            }
        },
    }
}
</script>

<style lang="less" type="text/less">
.stuContact .ant-col {
    display: flex;
    padding: 0;
    margin: 0;
}

.stuContact .ant-row {
    width: 100%;
    padding: 0;
    margin: 0;
}
</style>
<style scoped="scoped" type="text/less" lang="less">
.flexStretch {
    display: flex;
    justify-content: flex-start;
    align-items: stretch;
}

.stuContact {
    font-size: 20px;
    box-sizing: border-box;
    margin: 0 auto;
    padding: 25px 0;

    .title {
        font-size: 20px;
        //line-height: 50px;
    }

    .form {
        width: calc(100% - 50px);
        height: calc(100% - 80px);
        border: 1px solid #000;
        border-top: 0;

        div {
            //font-size: 14px;
            color: #323232;
            box-sizing: border-box;
        }

        .content {
            width: 100%;
            height: 100%;
            padding: 10px;
            white-space: break-spaces;
            word-break: break-all;
            overflow: hidden;
        }
    }

    .col-row {
        width: 100%;
        margin: 0;
        padding: 0;
    }
}


.stuContact {

    .table {
        width: 100%;
    }

    .borderR {
        border-right: 1px solid #333;
    }

    .borderB {
        border-bottom: 1px solid #333;
    }

    .FS18 {
        font-size: 18px;
    }

    .bold {
        font-weight: 700;
        font-family: Avenir, Helvetica, Arial, sans-serif;
    }

    .cell {
        border-left: 1px solid #333;
        border-top: 1px solid #333;

        min-height: 30px;
        //line-height: 30px;
        //text-align: center;
        white-space: nowrap;
        font-size: 14px;
        font-family: "宋体";
        word-break: break-all;
        white-space: normal;
    }

    .cell50 {
        min-height: 50px;
        line-height: 50px;
        font-size: 14px;
        font-family: "宋体";
    }

    .cellMore {
        border-left: 1px solid #333;
        border-top: 1px solid #333;
        min-height: 50px;
        text-align: left;
        font-size: 14px;
        font-family: "宋体";
    }
}

.uline {
    text-decoration: underline;
}
</style>
